import Vue from 'vue';
import moment from 'moment';
import VueI18n from 'vue-i18n';
import Cookies from 'js-cookie';
import VueRouter from 'vue-router';
import ElementUI from 'element-ui';
import * as echarts from 'echarts';

import elementEnLocale from 'element-ui/lib/locale/lang/en'; // element-ui lang
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'; // element-ui lang
import elementJaLocale from 'element-ui/lib/locale/lang/ja'; // element-ui lang

// import 'element-ui/lib/theme-chalk/index.css'; // elementUI默认主题
import '@/style/element-variables.scss'; // elementUI默认主题
import '@/style/element.scss'; // 全局elementUI样式重置
import '@/style/common.scss'; // 全局通用css
import App from './App.vue';
import router from './router';
import store from './store';
import axios from './utils/axios';
import mixins from './utils/mixins';
import baseMixins from './utils/mixins_base';
import plugin from './utils/plugin';
import directive from './utils/directive';
import Print from './utils/print';

// i18n国际化
Vue.use(VueI18n);

// class CustomFormatter {
//   interpolate(message, values, path) {
//     return !`${path}`.startsWith('el.') && path ? `${message}_${path}` : message;
//   }
// }

const i18n = new VueI18n({
  missing: () => ' ', // 如要遇到未翻译key则返回空字符串
  locale: Cookies.get('langCode') || 'CN',
  silentTranslationWarn: true,
  messages: {
    EN: { ...elementEnLocale },
    CN: { ...elementZhLocale },
    JPN: { ...elementJaLocale },
  },
  // formatter: localStorage.i18n ? new CustomFormatter() : undefined,
});
// 打印插件
Vue.use(Print);
// 挂载路由
Vue.use(VueRouter);
// 挂载框架  并且支持国际化
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value),
});
// 挂载插件
Vue.use(plugin, store);
// 注册全局mixins.
Vue.mixin(mixins);
Vue.mixin(baseMixins);
Vue.use(directive);
// 挂载axios/echarts
Vue.prototype.$http = axios;
Vue.prototype.$echarts = echarts;

// 设置周的开始时间是星期一 1月1号是年开始的第一周
// moment.updateLocale('en', {
//   week: {
//     dow: 1, // Monday is the first day of the week.
//     doy: 7, // The week that contains Jan 4th is the first week of the year.// 年份的第一周必须包含1月1日 (7 + 1 - 1)
//   },
// });

Vue.prototype.$moment = moment;
Vue.prototype.$momentUtc = moment.utc;

// var inFifteenMinutes = new Date(new Date().getTime() + 1 * 60 * 1000);
// Cookies.set('test', '99999', { expires: inFifteenMinutes, path: '/' });

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');
